import React from 'react';
import { IconButton, Menu } from '@mui/material';
import { MoreVert } from '@mui/icons-material';
import MenuItem from '@mui/material/MenuItem';

interface Props {
  config: { label: string; action: VoidFunction; disabled?: boolean }[];
}

export const ActionsMenu = ({ config }: Props) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton color="primary" className="icon-btn-bordered" onClick={handleClick}>
        <MoreVert color="primary" />
      </IconButton>

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {config.map(({ label, action, disabled = false }) => (
          <MenuItem
            key={label}
            disabled={disabled}
            onClick={() => {
              handleClose();
              action();
            }}
          >
            {label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
